export { default } from './Input';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Input/index.js
// module id = 322
// module chunks = 2